import React from 'react';
import './HomeHouses.scss';
import { NavLink } from 'react-router-dom';
import Images from '../../Assets/Images/Images';

const HomeHouses = () => {
  return (
    <div className='home-houses'>
      <div className='home-houses__col home-houses--left' style={{ backgroundImage: `url(${Images.homeHouseOne})` }}>
        <div className='overlay' />
        <NavLink className='home-houses__link' to={'/house-of-arie-one'}>
          <div className='home-houses__text-wrapper'>
            <p className='home-houses__title'>House Of Arie 1</p>
            <p className='home-houses__address'>Jl. Depsos Gg. H. Mardan No.72, RW.1, Bintaro, Kec. Pesanggrahan, Kota
              Jakarta Selatan, Daerah Khusus
              Ibukota Jakarta 12330</p>
          </div>
        </NavLink>
      </div>
      <div className='home-houses__col home-houses--right' style={{ backgroundImage: `url(${Images.homeHouseTwo})` }}>
        <NavLink className='home-houses__link' to={'/house-of-arie-two'}>
          <div className='home-houses__text-wrapper'>
            <p className='home-houses__title'>House Of Arie 2</p>
            <p className='home-houses__address'>Jl. Bhakti No.5, RT. 006/01, Bintaro, Pesanggrahan, Jakarta Selatan, DKI
              Jakarta Selatan</p>
          </div>
        </NavLink>
      </div>
    </div>
  )
};

export default HomeHouses;
